<template>
    <!-- 支付档位 -->
    <div class="coupon-wrap">
        <div @click="clickToCouponlist" class="line flex_layout flex_x_spacebetween flex_y_center">
            <div class="coupon-wrap-l flex_layout flex_xy_center">
                <div class="coupon-wrap-l-ico"></div>
                <span class="pf-regular">使用优惠券</span>
            </div>
            <div v-if="!h_visible_hascoupon" class="coupon-wrap-r flex_layout flex_xy_center pf-regular">
                <i>无可用优惠券</i><i class="opacity0"></i>
            </div>
            <div v-if="h_visible_hascoupon" class="coupon-wrap-r flex_layout flex_xy_center pf-regular">
                <i v-html="h_data_goodinfo.coupontitle"></i><i></i>
            </div>
        </div>
    </div>
</template>
<script>
    import {
        forward,
        receive_page_status
    } from '@kk/h5-sdk'
    import {
        ua,
        setCookie,
        miniNav,
        getRemoveNullObject,
    } from '@kkmh/utils'
    import {
        getPayInfo,
    } from "../../../assets/utils";
    export default {
        name: 'GoodCoupon',
            data () {
            return {
            }
        },
        props: {
            h_visible_hascoupon:false,
            h_data_goodinfo:{
                type: Object,
                default () {
                    return {}
                }
            },
            j_req:{
                type: Object,
                default () {
                    return {}
                }
            },
        },
        computed: {
            //头像
            avatar_url() {
                let {user={}} = this.value;
                return user.avatar_url;
            },
        },
        created() {
            
        },
        methods:{
            //打开优惠券列表页面
            changeCoupon(){
                this.$emit('changeCoupon');
            },
            //打开优惠券列表页面
            clickToCouponlist(){
                if (!this.h_visible_hascoupon) {
                    return null;
                }

                let url = location.protocol + '//' + location.host + '/webapp/vip/purchase_coupon.html';
                if (location.port) {
                    url = location.protocol +'//'+ location.hostname + ':8080/webapp/vip/purchase_coupon.html';
                }

                let good_id = this.h_data_goodinfo.id;
                let opt     = this.j_req;

                let v_coupon_param = {
                    good_id : good_id,
                    url     : '/v1/vip/member_good/list_h5',
                    // url     : 'https://yapi.quickcan.com/mock/341/v1/vip/member_good/list_h5?name=yingxiaoquyu',
                    // data    : {},//公众号的接口是用data传递的，用ajax  //axios:param | ajax:data
                    data    : {
                        third_activity              : opt.third_activity || '',
                        non_iap_supported_device    : opt.non_iap_supported_device || false,//是否越狱设备，true表示是
                        non_iap_supported           : opt.non_iap_supported || 0,//运营位是否支持越狱，1表示支持
                        compel_iap                  : opt.compel_iap || false,//什么场景传递?勾选越狱商品选择用iap支付时传递true下发iap商品
                        platform                    : opt.platform || 3, //1：安卓，2：ios，3：H5，优先取platform，如果platform没传，就按userAgent取
                        pay_info                    : getPayInfo(opt),
                    },
                    headers : {
                        "X-Device"      : opt.device_id || '',
                        "Muid"          : opt.muid || '',
                        "App-Info"      : opt.app_info || '',
                        "Package-Id"    : opt.package_id || '',
                    },
                };
                setCookie('V_COUPON_PARAM', JSON.stringify(v_coupon_param));

                if (ua['kkmh']) {
                    forward({
                        todata  : {},
                        totype  : 'h5',
                        topage  : url+'?type=hybridh5&good_id='+good_id,
                        callback : (res) => {
                            let {data={}} = res;
                            if (data.status == 1) { //跳转成功
                            }
                            if (data.status == 2) { //h5回来不执行
                            }
                        }
                    });
                    receive_page_status({
                        callback : (res, nativecallback_name) => {
                            let {data={}} = res;
                            //跳转成功
                            if (data.curr_page_is_visible == 0) {
                            }
                            //回来
                            if (data.curr_page_is_visible == 1) {
                                this.changeCoupon(); //重新刷新
                                if (nativecallback_name) {
                                    window[nativecallback_name]=function(){}; //释放内存
                                }
                            }
                        }
                    })
                } else {
                    let reurl = location.href+'&good_id='+good_id;
                    if (location.hash) {
                        reurl = location.protocol + '//' + location.host + '/' + location.search + '&good_id=' + good_id + location.hash
                    }
                    url = url+'?type=h5&reurl='+encodeURIComponent(reurl);
                    if(ua['miniprogram']) {
                        // let miniurl = location.protocol + '//' + location.host + '/webapp/mini/webapp_vip_purchase_coupon.html';
                        // if (location.port) {
                        //     miniurl = location.protocol +'//'+ location.hostname + ':8080/webapp/mini/webapp_vip_purchase_coupon.html';
                        // }
                        // let miniparam = JSON.stringify({
                        //     good_id         : activeItem.id,
                        //     third_activity  : '',
                        //     env             : 'p',//p or s
                        // });
                        // miniurl = `${miniurl}?type=h5&miniparam=${miniparam}`;
                        // miniNav(`/pages/webview/webview?url=${encodeURIComponent(miniurl)}`);

                        // miniNav(`/pages/webview/webview?url=${encodeURIComponent(url)}`);

                        location.href = url;
                    } else {
                        location.href = url;
                    }
                } 
                
            },
        },
    }
</script>
<style lang="scss">
@import "../../../assets/styles/mixins.scss";
.coupon-wrap{
    .coupon-wrap-r{
        padding-right:vws(8px);
        i:first-child {
            font-size: vws(24px);color:#666;
            .price{
                border-radius: vws(4px);font-size: vws(24px);padding: 0 0 0 vws(10px);
                span:first-child{
                    color:#666;margin-right:vws(20px);
                }
                span:last-child{
                    color:#FF4F00;font-weight:bold;
                }
            }
        }
        i:last-child{
            width:vws(24px);height:vws(24px);background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAAbFBMVEUAAADX19fHx8fLy8vIyMjIyMjIyMjHx8fJycnIyMjIyMjIyMjIyMjIyMj////Hx8fIyMjIyMjIyMjJycnHx8fIyMjIyMjKysrIyMjLy8vLy8vMzMzT09PKysrIyMjIyMjIyMjJycn////Hx8cRSXgIAAAAI3RSTlMACaQs+e3qujXz4tbAXQLIsp2BdXBoU0xCIh0ZFA7cqpQmBOyetlYAAACsSURBVDjLtdRJFoMgEARQQUCM4pA4RM3M/e8YiwNQLLTX/3XRvIbs1MqlzJkRxnu9EWT9Xh3rpKEcUQ5IP4gqoN4ErSXURNQIZFhgDSUJWkLgTNQAdHnGURMCe9Lqq6DuRN1CoCCBLdTINgaBRUaq21F1QCdR4UxDHH0Spps9v6fNwFwT9q798esul6ixCsix6fnO9TCv+DJNMMqyx8mntzB1k/BhrElfzzn1Bx3DFEGP4MrcAAAAAElFTkSuQmCC") no-repeat 0 0;background-size: 100% 100%;
        }
    }
}
</style>
<style lang="scss" scoped>
@import "../../../assets/styles/mixins.scss";
.coupon-wrap.show{display: block;}
.coupon-wrap{
    padding:0 vws(16px);margin-top: vws(24px);
    i {
        font-style: normal;
    }
    .line{
        border-top: 1px solid #eee;border-bottom: 1px solid #eee;padding: vws(22px) 0;
    }
    .coupon-wrap-l{
        font-size: vws(24px);color: #333;
    }
    .coupon-wrap-l-ico{
        width: vws(30px);height: vws(30px);margin-right: vws(8px);background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAtCAMAAAANxBKoAAAAe1BMVEUAAAD/UAD/UAD/UQD/VQD/TwD/TwD/UAD/TwD/TwD/TwD/TwD/UAD/UAD/UgD/UAD/VQD/VQD/TwD/////vZ//lmj/kGD/ayn/spD/+Pb/7eX/4NP/1cP/lGX/ZSD/Yx7/XRX/VAj/w6j/49j/3tD/nnP/iFP/gEj/cTIhWpOAAAAAEnRSTlMAgNJbHvjx5sGnjmdcUEE2JwONT7G+AAAA3ElEQVRIx+3T2QqDMBAFUGPtXte477v+/xd2MhQ0FR3okxQv6L3E8yREObKak+qsRz19YWc7MlcJrUraobJ/XVXTIHUfRT4OP4p6Urec8ww6g25JXXPkmaia1GWCTrySktIfPmFCF2ODuBkLUgcxnxIHhA75PCGhPUl7Wxq567opwBQaMKFFfNA+LlIXed6B7vL8+CezBKADSk8ZwmEHd/7v9Rme5Vrqizh52doNP11Nxbziumn2S/RF0g84uUNbaJ6wnrgsWHfohyJFZ8wQzUQ0GBoucWQwpiu/5A325VeuwOhiaAAAAABJRU5ErkJggg==") no-repeat 0 0;background-size: 100% 100%;
    }
}
</style>




// WEBPACK FOOTER //
// node_modules/@kkmh/pays/src/components/viphalfscreen/comp/GoodCoupon.vue